export default "__VITE_ASSET__DZTTk$38__"